import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocation, faHouse } from "@fortawesome/free-solid-svg-icons";
import { FiMapPin, FiHome, FiSearch, FiShield } from 'react-icons/fi';
import "../../css/Projects.css";

export const PropertySection = () => {
  
    const [project, setProject] = useState(null);
    const [media, setMedia] = useState([]);
    const [similarProjects, setSimilarProjects] = useState([]);
    const [almostready, setAlmostReady] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
       
            axios.get(`/api/new-homes-ready-to-move-in`)
                .then(res => {
                    console.log("res.data", res.data);
                    setSimilarProjects(res.data);
                })
                .catch(err => {
                    console.error("Error fetching similar projects:", err);
                });     
    }, [project]);
    useEffect(() => {
        axios.get(`/api/almost-ready`)
            .then(res => {
                console.log("res.data", res.data);
                setAlmostReady(res.data);
            })
            .catch(err => {
                console.error("Error fetching similar projects:", err);
            });
    
}, [project]);

   
    return (
       
        <div className="projects-section">
            <h2 className="section-title">Projects in Chennai  </h2>

            <div className="topic1">
                <h3 className="topic-title">
                <span className="diamond"></span>New Homes Ready to Move in <span className="diamond"></span></h3>

                <div className="projects-grid">
                    {Array.isArray(similarProjects) && similarProjects.slice(0, 3).map((project) => (
                        <a
                            key={project.projectid}
                            href={`/new-project/${project.projectid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="property-card1"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="card-image">
                                <img src={project.image} alt={project.bpn} />
                                <span className="badge verified "><FiShield /> Verified</span>
                                {/* <span className="badge status">Under Construction</span> */}
                            </div>
                            <div className="card-content">
                                <h3>{project.bpn}</h3>
                                <div className="flex">
                                <p className="developer">{project.builder}</p> |
                                <p className="devr">{project.property_type}</p>
                                </div>

                                <p className="icon-text">
                                    <FiMapPin /> {project.city}, {project.locality}
                                </p>
                                <div className='flex'>
                                    <p className="icon-text">
                                        <FiHome /> {project.bhk_range
                                            .replace(/bhk/gi, '')
                                            .split(',')
                                            .join('&') + ' BHK'}
                                    </p>
                                    <p className="icon-text">
                                        ₹{project.min_price} - ₹{project.max_price}
                                    </p>
                                </div>
                                <div className="card-actions"  >
                                    <button className="btn view">
                                        <FiSearch /> View Details
                                    </button>

                                </div>
                            </div>
                        </a>
                    ))
                    }
                </div>
                <button onClick={() => navigate('/ready-to-occupy-homes-in-chennai')} className="view-more">View More</button>
            </div>
<hr />
            <div className="topic1 topmargin">
                <h3 className="topic-title">
                <span className="diamond"></span>Almost Ready Projects <span className="diamond"></span></h3>

                <div className="projects-grid">
                    {Array.isArray(almostready) && almostready.slice(0, 3).map((project) => (
                        <a
                            key={project.projectid}
                            href={`/new-project/${project.projectid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="property-card1"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="card-image">
                                <img src={project.image} alt={project.bpn} />
                                <span className="badge verified "><FiShield /> Verified</span>
                                {/* <span className="badge status">Under Construction</span> */}
                            </div>
                            <div className="card-content">
                                <h3>{project.bpn}</h3>
                                <div className="flex">
                                <p className="developer">{project.builder}</p> |
                                <p className="devr">{project.property_type}</p>
                                </div>
                                <p className="icon-text">
                                    <FiMapPin /> {project.city}, {project.locality}
                                </p>
                                <div className='flex'>
                                    <p className="icon-text">
                                        <FiHome /> {project.bhk_range
                                            .replace(/bhk/gi, '')
                                            .split(',')
                                            .join('&') + ' BHK'}
                                    </p>
                                    <p className="icon-text">
                                        ₹{project.min_price} - ₹{project.max_price}
                                    </p>
                                </div>
                                <div className="card-actions"  >
                                    <button className="btn view">
                                        <FiSearch /> View Details
                                    </button>

                                </div>
                            </div>
                        </a>
                    ))
                    }
                </div>
              <div onClick={() => navigate('/completed-projects-in-chennai ')}>  <button className="view-more">View More</button> </div>
            </div>
                  </div>
       
    );
};
